import { ApplicationView, useController } from '@aha-app/mvc';
import React from 'react';
import WidgetsController from '../../../controllers/WidgetsController';
import WhiteboardController from '../../../controllers/WhiteboardController';

const TabComponent: React.FC = () => {
  const controller = useController(WidgetsController);
  const whiteboardController = useController(WhiteboardController);

  const timerWidget = controller.state.timerWidget;
  const currentUser = whiteboardController.state.userId;

  const timerActive =
    timerWidget &&
    currentUser &&
    timerWidget.active() &&
    timerWidget.belongsToUser(currentUser) &&
    timerWidget.remainingDuration() > 0;

  if (!timerActive || !whiteboardController.canFacilitate) {
    return null;
  }

  return (
    <aha-sidepanel-item>
      <i className='fa-regular fa-timer' />
    </aha-sidepanel-item>
  );
};

export default ApplicationView(TabComponent);
